<template>
  <v-layout column class="card-container">
    <v-flex class="card-subtitle mb-16"> {{ adminText('workflowsAll.add_shortcodes_to_your_e_mail_ddc453d', 'Add shortcodes to your e-mail') }} </v-flex>
    <div class="shortcode-wrapper">
      <div
        v-for="shortcode in visibleShortcodes"
        :key="shortcode"
        class="shortcode-container"
        @click="$emit('shortcode', shortcode)"
      >
        <span class="shortcode-text">{{ workflowLabel(shortcode) }}</span>
      </div>
    </div>
    <!-- <div v-if="shortcodesCountGreaterThan(8)">
      <v-flex
        v-if="!allVisible"
        class="large-text card-action mt-8 text-uppercase"
        @click="allVisible = true"
      >
        <span>See more</span>
        <v-icon color="primary">expand_more</v-icon>
      </v-flex>
      <v-flex v-else class="large-text card-action mt-8 text-uppercase" @click="allVisible = false">
        <span>See less</span>
        <v-icon color="primary">expand_less</v-icon>
      </v-flex>
    </div> -->
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'email-shortcodes',
  props: {
    shortcodes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      allVisible: false,
    }
  },
  computed: {
    visibleShortcodes() {
      return !this.allVisible ? this.shortcodes : this.shortcodes.slice(0, 8)
    },
  },
  methods: {
    shortcodesCountGreaterThan(count) {
      return this.shortcodes && this.shortcodes.length > count
    },
  },
}
</script>

<style scoped>
.card-container {
  background-color: white;
  padding: 24px 32px 24px 24px;
  border-radius: 8px 0 0 8px;
  border: 2px solid #f5f5f5;
}
.card-subtitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.large-text {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  color: #0277bd;
  cursor: pointer;
}
.shortcode-container {
  background-color: #f0f6fa;
  margin-bottom: 8px;
  border: 1px solid #cee4f2;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px;
  height: 24px;
  display: table;
  width: fit-content;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  display: inline-block;
  margin-left: 10px;
}
.shortcode-text {
  font-size: 14px;
  color: #0277bd;
  line-height: 24px;
}
.shortcode-wrapper {
  max-width: 300px;
  padding-right: 10px;
}
@media screen and (max-width: 1279px) {
  .shortcode-wrapper {
    max-width: 100%;
  }
}
</style>
